import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=d2735cc8&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=d2735cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2735cc8",
  null
  
)

export default component.exports